function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Hand Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M8.939,1.594 C9.83236017,1.594 10.573,2.28958874 10.573,3.159 L10.573,6.7199991 C10.7685485,6.64074241 10.9829723,6.597 11.207,6.597 C12.100424,6.597 12.842,7.29262174 12.842,8.162 L12.842,13.323 C12.842,16.0884308 10.2963446,18.446 6.667,18.446 C3.11647796,18.446 0.5,16.0340984 0.5,13.323 L0.5,6.15 C0.5,5.28058874 1.24063983,4.585 2.134,4.585 C2.35802767,4.585 2.57245146,4.62874241 2.768,4.7079991 L2.768,4.026 C2.768,3.15757247 3.50965807,2.461 4.402,2.461 C4.62600083,2.461 4.84043134,2.50480736 5.036,2.58415397 L5.036,2.065 C5.036,1.19562174 5.77757602,0.5 6.671,0.5 C7.44634969,0.5 8.10756047,1.02498867 8.26793847,1.73254244 C8.47332575,1.64348054 8.70073101,1.594 8.939,1.594 Z M7.305,2.065 C7.305,1.76278559 7.02502442,1.5 6.671,1.5 C6.31606776,1.5 6.036,1.76271241 6.036,2.065 L6.036,9.473 C6.036,10.1396667 5.036,10.1396667 5.036,9.473 L5.036,4.026 C5.036,3.7239673 4.75618237,3.461 4.402,3.461 C4.04840989,3.461 3.768,3.7243637 3.768,4.026 L3.768,9.473 C3.768,10.1396667 2.768,10.1396667 2.768,9.473 L2.768,6.15 C2.768,5.84738936 2.48861651,5.585 2.134,5.585 C1.77938349,5.585 1.5,5.84738936 1.5,6.15 L1.5,13.323 C1.5,15.4628119 3.65140127,17.446 6.667,17.446 C9.76047704,17.446 11.842,15.5182708 11.842,13.323 L11.842,8.162 C11.842,7.85971241 11.5619322,7.597 11.207,7.597 C10.8523835,7.597 10.573,7.85938936 10.573,8.162 L10.573,9.473 C10.573,10.1396667 9.573,10.1396667 9.573,9.473 L9.573,3.159 C9.573,2.85638936 9.29361651,2.594 8.939,2.594 C8.58438349,2.594 8.305,2.85638936 8.305,3.159 L8.305,9.473 C8.305,10.1396667 7.305,10.1396667 7.305,9.473 L7.305,2.065 Z",
  id: "hand-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "hand-Icon/Global/provider",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "hand-Swatches/Midnight",
  transform: "translate(6.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "hand-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#hand-path-1"
})));

var SvgHand = function SvgHand(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHand, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hand.a3bc3f84.svg";
export { ForwardRef as ReactComponent };